module.exports = __webpack_public_path__ + "media/images/products/products/v4-4066e5ce20d16b01c5c00886d51787f8.jpg";